import branch, { SessionData } from 'branch-sdk'
import { AppConfig } from '../domain/config'
import { logger } from './logger'

// Branch methods will fail if not initialized
export const initBranch = (config: AppConfig): void => {
  const {
    variables: { BRANCH_API_KEY }
  } = config

  BRANCH_API_KEY && branch.init(BRANCH_API_KEY)
}

// parse and use any Branch link data
export const useBranchLinkData = (
  useLinkData: (data: LinkData) => void
): void =>
  branch.data((err, data: SessionData) => {
    logger.debug('useBranchLinkData', err, data)
    if (data?.data_parsed) {
      useLinkData(data.data_parsed)
    } else {
      useLinkData({ promo_code: null, referral_code: null })
    }
  })

export const setBranchUser = (identity: string): void => {
  branch.setIdentity(identity)
}

export const resetBranch = (): void => {
  branch.logout()
}

type LinkData = ReferralLinkData | Record<string, unknown>

export type ReferralLinkData = {
  promo_code?: string
  referral_code?: string
}

// log Branch custom events
export const postBranchLogEvent = (event: BranchLogEvent): void =>
  branch.logEvent(event)

export const BRANCH_LOG_EVENTS = {
  APP_STARTED: 'card_application_started',
  APP_SUBMITTED: 'card_application_submitted',
  APP_PREAPPROVED: 'card_application_preapproved',
  APP_ACCEPTED: 'card_application_accepted'
}

type EventTypes = keyof typeof BRANCH_LOG_EVENTS
export type BranchLogEvent = typeof BRANCH_LOG_EVENTS[EventTypes]
